import {Box, Checkbox, TypographyVariants} from '@gwc/main'
import clsx from 'clsx'
import React, {useId} from 'react'

import {Typography} from '../typography'
import {classes} from './Checkbox.classes'
import {CheckboxProps, CheckboxSize} from './Checkbox.types'

const typographyVariants: Record<CheckboxSize, TypographyVariants> = {
  m: 'body2',
  s: 'caption1',
}

const Checkboxv2 = React.memo(function Checkboxv2({
  className,
  error,
  name,
  checked,
  label,
  size = 'm',
  isIndeterminate,
  id: externalId,
  ...props
}: CheckboxProps) {
  const internalId = useId()
  const id = externalId || internalId

  return (
    <>
      <Box alignItems="center" flexWrap="nowrap">
        <Checkbox
          checked={checked}
          className={clsx(classes.checkbox, !!error && classes.checkboxError, className)}
          error={!!error}
          indeterminate={isIndeterminate}
          labelId={id}
          name={name}
          size={size}
          {...props}
        />
        {!!label && (
          <Typography
            className={classes.label}
            Component="label"
            htmlFor={id}
            ml="m"
            variant={typographyVariants[size]}
          >
            {label}
          </Typography>
        )}
      </Box>
      {!!error && (
        <Typography color="error" variant="caption2">
          {error}
        </Typography>
      )}
    </>
  )
})

export default Checkboxv2
